var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShares128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1895 93.9732C27.7125 93.9732 31.3792 90.3065 31.3792 85.7835C31.3792 81.2604 27.7125 77.5938 23.1895 77.5938C18.6664 77.5938 14.9998 81.2604 14.9998 85.7835C14.9998 90.3065 18.6664 93.9732 23.1895 93.9732Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8059 62.2378C54.329 62.2378 57.9956 58.5712 57.9956 54.0481C57.9956 49.5251 54.329 45.8584 49.8059 45.8584C45.2829 45.8584 41.6162 49.5251 41.6162 54.0481C41.6162 58.5712 45.2829 62.2378 49.8059 62.2378Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4224 81.6885C80.9454 81.6885 84.6121 78.0218 84.6121 73.4988C84.6121 68.9757 80.9454 65.3091 76.4224 65.3091C71.8993 65.3091 68.2327 68.9757 68.2327 73.4988C68.2327 78.0218 71.8993 81.6885 76.4224 81.6885Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.087 46.8823C109.61 46.8823 113.276 43.2157 113.276 38.6926C113.276 34.1696 109.61 30.5029 105.087 30.5029C100.564 30.5029 96.897 34.1696 96.897 38.6926C96.897 43.2157 100.564 46.8823 105.087 46.8823Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0254 80.6304L46.3029 61.1235",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8926 58.3369L70.826 67.8117",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9731 67.8116L99.808 45.5181",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShares128);
export default __webpack_public_path__ + "static/media/pictogramBeaconShares128.8ceb59ef90d63827a3b19ccb075597c1.svg";
export { ForwardRef as ReactComponent };